import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container } from 'react-bootstrap';
import OuvidoriaService from '../../../../services/ouvidoria';
import { Link } from 'react-router-dom';



const FormBusca = (props) => {
    const [email, setEmail] = useState("");
    const [numero, setNumero] = useState("");



    const busca = async (query) => {
        if (query == "") {
            props.setVazio(true)
        } else {
            var response = await OuvidoriaService.buscar(query)
            if (response.data.length >= 1) {
                props.setRequisicoes(response.data)
                props.setVazio(false)
            } else {
                props.setVazio(true)
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (email) prepQuery = prepQuery + `&email=${encodeURI(email)}`;
        if (numero) prepQuery = prepQuery + `&numero=${encodeURI(numero)}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={4}>
                        <Col>
                            <Form.Group className="mb-3" controlId="Número do protocolo">
                                <FloatingLabel
                                    label="Número do Protocolo"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="numero"
                                        value={numero}
                                        onChange={e => setNumero(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                        <p>OU</p>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="email">
                                <FloatingLabel
                                    label="Email"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="email"
                                        value={email}
                                        onChange={e => setEmail(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>


                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/ouvidoria'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca